import ActionButton from './actionButton';
import { Typography } from "@mui/material";
import Container from '@mui/material/Container';
import { useState, useEffect, useContext } from 'react'
import EventContext from "../store/event-context";

const ActivesCount = ({ activesCount, refresh }) => {

    const eventctx = useContext(EventContext);

  useEffect(() => {
    setInterval(() => {
      refresh();
    }, 2000);
  }, []);

    return (
        <div>
             <Typography display="inline"> Zwemmers te water: </Typography>
             <Typography display="inline" sx={{fontSize: '20px', fontWeight: 'bold'}}>{activesCount}</Typography>
        </div>
    )
}

export default ActivesCount

